export enum Key {
  Enter = 'Enter',
  Tab = 'Tab',
  ArrowDown = 'ArrowDown',
  ArrowUp = 'ArrowUp',
  Escape = 'Escape',
  Space = ' ',
  End = 'End',
  Home = 'Home',
}
